import { sectionContext, itemContext } from 'context'
import { Item } from 'schema'

class Section {
    constructor(props){
        let updatedProps = props || {}
        this._id = updatedProps.sectionID;
        this.sectionID = updatedProps.sectionID || updatedProps['_id'] || '';
        this.pageID = updatedProps.pageID;
        this.section_name = updatedProps.section_name;
        this.items = updatedProps.items || {INCOMPLETE: [], COMPLETED: []};
        this.createdBy = updatedProps.createdBy
        this.updatedBy = updatedProps.updatedBy;

        this.status = updatedProps.status || sectionContext.STATUS.ACTIVE;
        this.create_date = updatedProps.create_date || new Date().toString().slice(0,24);
        this.items_visibility = updatedProps.items_visibility !== undefined ? updatedProps.items_visibility : true;
        this.show_completed = updatedProps.show_completed !== undefined ? updatedProps.show_completed : true;
        this.show_children = updatedProps.show_children !== undefined ? updatedProps.show_children : true;
        
        this.details = {
            pageID: this.pageID,
            section_name: this.section_name,
            status: this.status,
            items: this.items,
            create_date: this.create_date,
            items_visibility: this.items_visibility,
            show_completed: this.show_completed,
            show_children: this.show_children,
        }
    }

    gotChildren(completed){
        const gotIncomplete = this.items && this.items['INCOMPLETE'] ? Object.values(this.items['INCOMPLETE']).length > 0 : false
        const gotCompleted = this.items && this.items['COMPLETED'] ? Object.values(this.items['COMPLETED']).length > 0 : false
        if(completed){
            return gotIncomplete & gotCompleted
        } else {
            return gotIncomplete
        }
    }

    childHandler = (itemID, item, status_list, data) => {
        let result = {keys: [], nodes: []}
        if(item){
            const item_details = item
            const childrenIDs = item_details['children']
            const show_children = item_details['children_visibility']
            result['keys'].push(itemID)
            result['nodes'].push(item)
            status_list.map((status, index) => {
                if(childrenIDs){
                    if(childrenIDs[status] && show_children){
                        for(const childID of Object.values(childrenIDs[status])) {
                            const child = data['items'][childID]
                            const int_result = this.childHandler(childID, child, status_list, data)
                            result['keys'] = result['keys'].concat(int_result['keys'])
                            result['nodes'] = result['nodes'].concat(int_result['nodes'])
                        }
                    }
                }
            })
        } 
        return result
    }

    buildView(rootOnly, data, show_completed){
        let items = {keys: [], nodes: []}
        let completedItems = {keys: [], nodes: []}
        const status_list = show_completed ? [itemContext.STATUS.INCOMPLETE, itemContext.STATUS.COMPLETED] : [itemContext.STATUS.INCOMPLETE]

        if(this.items){
            // Incompleted root items
            if(this.items[itemContext.STATUS.INCOMPLETE]) {
                // console.log(this.items[itemContext.STATUS.INCOMPLETE])
                Object.values(this.items[itemContext.STATUS.INCOMPLETE]).map(itemID => {
                    // if(itemID){
                    if(itemID && data['items'][itemID]){
                        // Allow items with status issue to show
                        if(rootOnly){
                            items['keys'].push(itemID)
                            items['nodes'].push(data['items'][itemID])
                        } else if(this.show_children){
                            const result = this.childHandler(itemID, data['items'][itemID], status_list, data)
                            items['keys'] = items['keys'].concat(result['keys'])
                            items['nodes'] = items['nodes'].concat(result['nodes'])
                        } else {
                            items['keys'].push(itemID)
                            items['nodes'].push(data['items'][itemID])
                        }
                    }
                    
                })
            }
            // Completed root items
            if(this.items[itemContext.STATUS.COMPLETED]) {
                Object.values(this.items[itemContext.STATUS.COMPLETED]).map(itemID => {
                    if(itemID && data['items'][itemID]){
                        if(data['items'][itemID]['status'] === itemContext.STATUS.COMPLETED){ // Additional check to prevent onCheck issues from rendering
                            if(rootOnly){
                                items['keys'].push(itemID)
                                items['nodes'].push(data['items'][itemID])
                            } else if(this.show_children){
                                const result = this.childHandler(itemID, data['items'][itemID], status_list, data)
                                items['keys'] = items['keys'].concat(result['keys'])
                                items['nodes'] = items['nodes'].concat(result['nodes'])
                            } else {
                                items['keys'].push(itemID)
                                items['nodes'].push(data['items'][itemID])
                            }
                        }
                    }                    
                })
            }
        }
        
        let result = items
        result['keys'] = result['keys'].concat(completedItems['keys'])
        result['nodes'] = result['nodes'].concat(completedItems['nodes'])
        result = result['keys'].length > 0 ? Object.assign(...items['keys'].map((k, i) => ({[k]: items['nodes'][i]}))) : null;

        return result
        
    }
}

export default Section;